module.exports = __webpack_public_path__ + "static/img/1_0.fe175f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new/1_0.png
// module id = PEOY
// module chunks = 0